import * as React from 'react';
import autobind from 'autobind-decorator';
import { observable } from "mobx";
import { observer } from "mobx-react";
import { Button, Menu, Dropdown, Input, Select } from 'antd';

import { ZuluIcon } from 'src/app/shared/icon';

const InputGroup = Input.Group;
const Option = Select.Option;

export type FilterEditorType = 'foreignKey' | 'string' | 'number' | 'date' | 'boolean';

interface FilterEditorProps {
	items?: any[]; //IContextualMenuItem[];
	filterType?: FilterEditorType;
    operatorCheck?: (obj: FilterOperator) => boolean;
    onClick: (item: string) => void;
}

@observer
export class FilterEditorView extends React.Component<FilterEditorProps, any> {

    @observable
    isVisible = false;

    @observable
    showCallout = false;

    target: any;

    render() {
        let items = this.props.items;
        if (items == null) {
            if (this.props.filterType == null || this.props.operatorCheck == null) {
                throw Error('Filter type and filter items cannot be null!');
            }

            items = [
                {
                    key: 'eq',
                    name: 'Equals',
                    checked: this.props.operatorCheck('eq'),
                    canCheck: true
                },
                {
                    key: 'ne',
                    name: 'Not equals',
                    checked: this.props.operatorCheck('ne'),
                    canCheck: true
                }
            ]
            switch (this.props.filterType) {
                case 'foreignKey':
                case 'boolean':
                    break;
                case 'string': {
                    items = items.concat([
                        {
                            key: 'contains',
                            name: 'Contains',
                            checked: this.props.operatorCheck('contains'),
                            canCheck: true
                        },
                        {
                            key: 'startsWith',
                            name: 'Starts width',
                            checked: this.props.operatorCheck('startsWith'),
                            canCheck: true
                        },
                        {
                            key: 'endsWith',
                            name: 'Ends width',
                            checked: this.props.operatorCheck('endsWith'),
                            canCheck: true
                        }
                    ]);
                    break;
                }
                case 'number':
                case 'date': {
                    items = items.concat([
                        {
                            key: 'gt',
                            name: 'Greather than',
                            checked: this.props.operatorCheck('gt'),
                            canCheck: true
                        },
                        {
                            key: 'ge',
                            name: 'Greather than or equals',
                            checked: this.props.operatorCheck('ge'),
                            canCheck: true
                        },
                        {
                            key: 'lt',
                            name: 'Less than',
                            checked: this.props.operatorCheck('lt'),
                            canCheck: true
                        },
                        {
                            key: 'le',
                            name: 'Less than or equals',
                            checked: this.props.operatorCheck('le'),
                            canCheck: true
                        }
                    ]);
                    break;
                }
            }
        }
        const menus = <Menu onClick={this.selectItem}>
            {
                items.map(i => <Menu.Item key={i.key} disabled={!i.canCheck}>
					<ZuluIcon type={i.checked ? 'check-square' : 'icon-square'} className='mr1' />
                    {i.name}
                </Menu.Item>)
            }
        </Menu>;
        return (
            <div className='panel filter-panel' style={{ minWidth: '200px' }}>
                {this.props.children}
                <Dropdown overlay={menus} trigger={['click']} placement='bottomRight'>
                    <Button type="primary" style={{ minWidth: 'auto', width: '40px' }} icon="ellipsis">
                    </Button>
                </Dropdown>
            </div>
        );
        //return <div className='panel' style={{ minWidth: '200px' }}>
        //    <InputGroup compact>
        //        {this.props.children}
        //        <Select value={items.find(e => e.checked).key} onChange={this.selectItem} style={{ width: '100px' }}>
        //            {
        //                items.map(i => <Option disabled={!i.canCheck} value={i.key}>{i.name}</Option>)
        //            }
        //        </Select>
        //    </InputGroup>
        //</div>
    }

    @autobind
    private selectItem(item: any): void {
        this.props.onClick(item.key);
    }
}



// WEBPACK FOOTER //
// ./src/core/ui/filter-editor.view.tsx